/** TanStack Query hook for current authenticated user */

import { useQuery } from '@tanstack/react-query'
import { apiClient, ApiError } from '../lib/api-client'
import type { User } from '@agentwiki/shared'

/** Shape of GET /api/auth/me — wrapper around the inner User. */
interface AuthMeResponse {
  user: User
  tenantId: string
  role: string
}

export function useAuth() {
  const query = useQuery<AuthMeResponse, ApiError>({
    queryKey: ['auth', 'me'],
    queryFn: () => apiClient.get<AuthMeResponse>('/api/auth/me'),
    retry: false,
    staleTime: 1000 * 60 * 5, // 5 minutes
  })

  return {
    /** The inner User object (flat). Null until /me resolves. */
    user: query.data?.user ?? null,
    /** Tenant the current user is acting as. */
    tenantId: query.data?.tenantId ?? null,
    /** Role within tenantId (admin / member). */
    role: query.data?.role ?? null,
    isLoading: query.isLoading,
    isAuthenticated: !!query.data,
    error: query.error,
    refetch: query.refetch,
  }
}
